import styled from 'styled-components';
import { body2, colors } from 'ui/theme';

export const StyledInnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 12px;
  align-items: center;
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

export const LastModifiedDate = styled.div`
  ${body2}
  white-space: nowrap;
`;

export const CreatedContainer = styled.div`
  ${body2};
  color: ${colors.textSecondary};
  font-size: 12px;
  line-height: 16px;
`;

export const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
